import React from 'react';
import {
  DisclaimerWrapper,
  ModelTrimHeaderWrapper,
  ModelTrimWrapper,
  ModelTrimYearWrapper,
  MSRPPriceWrapper,
  MSRPWrapper,
  TrimTextWrapper,
} from './styled';
import {
  BreakpointConfigType,
  Breakpoints,
  SupDisclaimer,
  TextAppearance,
  TextColor,
  TextCustom,
  TextLineHeight,
  TextSize,
  TextStyle,
  TextTag,
  TextWeight,
} from '@vw-marketing/us-components';
import { SecondayColorTextWrapper } from '../styled';
import { OfferInformation } from '../../../../hooks-store/typings/incentive-store';
import { getMSRPValue, separateThousand } from '../../../../utils/general';
import { useModelsConfig } from '../../../../hooks/use-models-config';
import { useTranslations } from '../../../../hooks/use-translations';

const textStyles: {
  [key: string]: TextStyle | BreakpointConfigType<TextStyle>;
} = {
  headline200Bold: {
    [Breakpoints.default]: {
      fontSize: TextSize.TextSize16,
      fontWeight: TextWeight.bold,
      lineHeight: TextLineHeight.TextLineHeight20,
    },

    [Breakpoints.b1600]: {
      fontSize: TextSize.TextSize20,
      fontWeight: TextWeight.bold,
      lineHeight: TextLineHeight.TextLineHeight24,
    },
  },
  headline200: {
    [Breakpoints.default]: {
      fontSize: TextSize.TextSize16,
      lineHeight: TextLineHeight.TextLineHeight20,
    },

    [Breakpoints.b1600]: {
      fontSize: TextSize.TextSize20,
      lineHeight: TextLineHeight.TextLineHeight24,
    },
  },
  label150: {
    [Breakpoints.default]: {
      fontSize: TextSize.TextSize14,
      lineHeight: TextLineHeight.TextLineHeight16,
    },

    [Breakpoints.b1600]: {
      fontSize: TextSize.TextSize16,
      lineHeight: TextLineHeight.TextLineHeight20,
    },
  },
};

const disclaimerTextStyle = {
  tag: TextTag.span,
  appearance: TextAppearance.headline200,
  style: {
    [Breakpoints.default]: {
      fontWeight: TextWeight.bold,
      color: TextColor.inherit,
      fontSize: TextSize.TextSize20,
      lineHeight: TextLineHeight.TextLineHeight24,
    },
    [Breakpoints.b960]: {
      fontWeight: TextWeight.bold,
      color: TextColor.inherit,
      fontSize: TextSize.TextSize16,
      lineHeight: TextLineHeight.TextLineHeight20,
    },
    [Breakpoints.b1600]: {
      fontWeight: TextWeight.bold,
      color: TextColor.inherit,
      fontSize: TextSize.TextSize24,
      lineHeight: TextLineHeight.TextLineHeight28,
    },
  },
};
interface ModelTrimHeaderProps {
  offerInformation: OfferInformation;
}

const ModelTrimHeader: React.FC<ModelTrimHeaderProps> = ({
  offerInformation,
}) => {
  const isLeaseSalesEvent =
    offerInformation.specialOffer?.dealOfferTypes[0].toLowerCase() === 'lease';
  const modelOverview = useModelsConfig();
  const year = offerInformation?.specialOffer?.dealCarYear[0];
  const model = offerInformation.modelDisplayName;
  const trim = offerInformation?.specialOffer?.dealCarTrimName[0];
  const modelMsrp = getMSRPValue(offerInformation, modelOverview);
  const MSRP = separateThousand(modelMsrp || '0');
  const translations = useTranslations().salesEvent.cardContent;

  return (
    <ModelTrimHeaderWrapper>
      <ModelTrimYearWrapper isLeaseSalesEvent={isLeaseSalesEvent}>
        <TextCustom
          appearance={TextAppearance.headline200}
          tag={TextTag.p}
          style={textStyles.headline200Bold}
        >
          <SecondayColorTextWrapper>{year}</SecondayColorTextWrapper>
        </TextCustom>
        <ModelTrimWrapper>
          <TextCustom
            appearance={TextAppearance.headline200}
            tag={TextTag.p}
            style={textStyles.headline200Bold}
          >
            {model}
          </TextCustom>
          <TextCustom
            appearance={TextAppearance.headline200}
            tag={TextTag.p}
            style={{
              [Breakpoints.default]: {
                fontSize: TextSize.TextSize16,
                lineHeight: TextLineHeight.TextLineHeight20,
              },

              [Breakpoints.b1600]: {
                fontSize: TextSize.TextSize20,
                lineHeight: TextLineHeight.TextLineHeight24,
              },
            }}
          >
            <TrimTextWrapper> {trim} </TrimTextWrapper>
          </TextCustom>
        </ModelTrimWrapper>
      </ModelTrimYearWrapper>
      {!isLeaseSalesEvent && (
        <MSRPWrapper>
          <TextCustom
            appearance={TextAppearance.label150}
            tag={TextTag.p}
            style={textStyles.label150}
          >
            <SecondayColorTextWrapper>
              {translations.msrpStartingLabel}{' '}
            </SecondayColorTextWrapper>
          </TextCustom>
          <MSRPPriceWrapper>
            <TextCustom
              appearance={TextAppearance.headline200}
              tag={TextTag.p}
              style={textStyles.headline200Bold}
            >
              {MSRP}
            </TextCustom>
            <DisclaimerWrapper>
              <TextCustom {...disclaimerTextStyle}>
                {/*@ts-ignore */}
                <SupDisclaimer>1</SupDisclaimer>
              </TextCustom>
            </DisclaimerWrapper>
          </MSRPPriceWrapper>
        </MSRPWrapper>
      )}
    </ModelTrimHeaderWrapper>
  );
};
export default ModelTrimHeader;
